
import Vue from 'vue'
import { mixins } from 'cms3-shop-module-ts'

export default Vue.extend({
  mixins: [mixins.UiPagination],

  props: {
    /**
     * * Количество страниц
     */
    totalPages: {
      type: Number,
      required: true,
      default: 0
    },

    /**
     * * Последняя выбранная страница из мета данных
     */
    latestCurrentPage: {
      type: Number,
      required: true,
      default: 0
    },

    /**
     * * Сколько отображать дополнительных страниц в начале пагинации
     */
    listLength: {
      type: Number,
      default: 6
    }
  }
})
